var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPushesInact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#ffffff",
    stroke: "#D1D5DB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4467 9.33203C19.22 9.33203 18.2267 10.332 18.2267 11.552C18.2267 12.772 19.22 13.7787 20.4467 13.7787C21.6733 13.7787 22.6667 12.7787 22.6667 11.552C22.6667 10.3254 21.6733 9.33203 20.4467 9.33203Z",
    fill: "#D1D5DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.56 14.692V19.8854C21.56 21.4187 20.3133 22.6654 18.78 22.6654H12.1133C10.58 22.6654 9.33333 21.4187 9.33333 19.8854V13.2187C9.33333 11.692 10.58 10.4454 12.1133 10.4454H17.3067C17.1867 10.792 17.1133 11.1654 17.1133 11.552C17.1133 13.392 18.6067 14.8854 20.4467 14.8854C20.84 14.8854 21.2067 14.8187 21.56 14.692Z",
    fill: "#D1D5DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushesInact);
export default __webpack_public_path__ + "static/media/pushesInact.913fac6c04ab41f8811ba97133f3895b.svg";
export { ForwardRef as ReactComponent };